/**
 * A book shown one spread at a time, centred, with the arrows and the page label under it to turn
 * the pages. Read only : mobile.common.LandscapePreview shows it as it is when the phone is turned
 * sideways.
 *
 * Triggers "previous" and "next" when the page changes.
 */
fx.ns("shared.preview", class BookPreview extends fx.Component
{
	constructor(data)
	{
		super(data);

		this._index = 0;
	}

	get book()
	{
		return this.data.creation;
	}

	get currentArea()
	{
		return this.area;
	}

	get coverLabel()
	{
		return this.book.coverName;
	}

	getArea(id)
	{
		return this.area;
	}

	// --------------------------- RENDER --------------------------- //

	create()
	{
		super.create();

		this.createOverlays();

		this.area = new shared.stage.BookArea(this.book.cover, this.data, this, "right", true);
		this.area.hideLabels = true;
		this.addChild(this.area, {height:this.book.coverHeight});

		this.createButtons();
	}

	// the arrows and the page label, in a row under the book
	createButtons()
	{
		this.buttonsContainer = new fx.components.HBox();
		this.leftArrow = new fx.components.IconButton({icon: fx.get("assets").previousIcon, className : "direction"});
		this.pageLabel = new fx.components.Text({className : "page-label"});
		this.rightArrow = new fx.components.IconButton({icon : fx.get("assets").nextIcon, className : "direction"});
		this.buttonsContainer.addChild(this.leftArrow, {width:50, height:50});
		this.buttonsContainer.addChild(this.pageLabel, { width : 200, height : 30});
		this.buttonsContainer.addChild(this.rightArrow, {width:50, height:50});

		this.addChild(this.buttonsContainer, {width : 300, height:  50, left : "center", bottom : 0});
	}

	// components laid under the book, before it is added : the desktop preview's frames
	createOverlays() {}

	onReady()
	{
		this.on("click", this.onPrevious, this.leftArrow);
		this.on("click", this.onNext, this.rightArrow);

		this.updatePage();
	}

	onDataEvent(event)
	{
		super.onDataEvent(event);

		switch(event.type)
		{
			case "cover-updated" :
				this.updateDisplay();
				break;
		}
	}

	updateDisplay()
	{
		super.updateDisplay();

		// resize area
		let percentage = this.book.shape_option == "landscape" ? 0.95 : 0.8,
			buttonsMinBottomMargin = 20,
			buttonsMinTopMargin = 30,
			width = this.realWidth,
			height = this.realHeight - this.buttonsContainer.realHeight + buttonsMinBottomMargin,
			screenWidth = width* percentage,
			screenHeight = Math.min(Math.max(0,height), height * percentage),
			ratio = this.book.coverHeight/this.book.coverWidth,
			scale = (screenWidth * ratio < screenHeight) ? (screenWidth / this.book.coverWidth ) : (screenHeight / this.book.coverHeight),
			xPos = (width/scale - (this.area.realWidth )) / 2 ,
			yPos = (height/scale - (this.book.coverHeight )) / 2,
			left, bottom ;

		this.area.css({ "transform" : "scale(" + scale + ") translate(" + 0 + "px) translate(" + xPos + "px," + yPos + "px)" });

		bottom = Math.max(buttonsMinBottomMargin, this.realHeight - ((yPos*scale + this.book.coverHeight * scale) + buttonsMinTopMargin) - this.buttonsContainer.realHeight );
		left = Math.max(0, (width - this.buttonsContainer.realWidth) / 2);
		this.buttonsContainer.viewport({bottom : bottom, left : left});
	}

	onPrevious()
	{
		if (this._index > 0)
		{
			this._index--;
			this.updatePage();

			this.trigger("previous");
		}
	}

	onNext()
	{
		if (this._index < this.book.pages.length)
		{
			this._index++;
			this.updatePage();

			this.trigger("next");
		}
	}

	firstPage()
	{
		this._index = 0;
		this.updatePage();
	}

	/**
	 * Opens the preview on the spread of the given page : one of book.pages, or the cover, its front
	 * by default, its back with side "left" (the last spread of the preview).
	 * @param {models.ProductBookPage} page
	 * @param {String} side
	 */
	showPage(page, side)
	{
		let index = 0;

		if (page && page.isCover)
			index = (side == "left") ? this.book.pages.length : 0;
		else
		if (page)
			index = Math.max(0, this.book.pages.indexOf(page));

		this._index = index;

		if (this.initialized)
			this.updatePage();
	}

	updatePage()
	{
		let page = (this._index == this.book.pages.length) ? this.book.cover : this.book.pages.getItemAt(this._index);
		this.area.displayedSide = page.isCover ? (this._index == 0 ? "right" : "left") : "";
		this.area.page = page;
		this.pageLabel.text = page.label();
		this.updateDisplay();

		this.leftArrow.enabled = this._index > 0;
		this.rightArrow.enabled = this._index < this.book.pages.length;

		if (page.isCover)
			this.area.activePart = "";
	}

	destroy()
	{
		super.destroy();

		this.area.destroy();

		this.leftArrow.destroy();
		this.pageLabel.destroy();
		this.rightArrow.destroy();

		this.buttonsContainer.destroy();
	}
});
